import * as React from 'react';
import { stylesheet } from 'typestyle';

import { CategoryLabelModel } from '@src/models';
import swanIcon from '@src/images/icons/swan-logo.svg';

type SupportedLabelType = Exclude<
  CategoryLabelModel['type'],
  'LABEL_TYPE_PRIORITY' | 'LABEL_TYPE_SUSTAINABILITY'
>;
const labelTypePreviewMap: Record<
  SupportedLabelType,
  {
    label: string;
    icon?: string;
  }
> = {
  LABEL_TYPE_CUSTOM: {
    label: 'Custom',
  },
  LABEL_TYPE_SWAN: {
    label: 'Swan',
    icon: swanIcon,
  },
};

export const LabelTypePreview: React.FC<{
  type: SupportedLabelType;
}> = ({ type }) => {
  const { label, icon } = labelTypePreviewMap[type];
  return (
    <div className={styles.flexWrapper}>
      {icon && <img className={styles.typeIcon} src={icon} draggable="false" />}
      <span className={styles.type}>{label}</span>
    </div>
  );
};

const styles = stylesheet({
  flexWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  typeIcon: {
    height: '14px',
    width: '14px',
  },
  type: {
    marginLeft: '4px',
  },
});
